import {dispatchTrackEvent} from "./_tracking";
import scrollLock from "./_scroll-lock";

export default function initMenu() {
  initMenuToggle();
}

function initMenuToggle() {
  document.getElementById('toggleNav')
    ?.addEventListener('click', (e) => toggleMobileMenu(e.target));
}

function toggleMobileMenu(toggleNav, toggle = true) {
  const nav = toggleNav.parentElement.nextElementSibling;

  if (toggle) {
    toggleNav.classList.toggle('open');
    nav.classList.toggle('open');
    document.body.classList.toggle('scroll-lock');
    if (toggleNav.classList.contains('open')) {
      scrollLock.enable();

      window.addEventListener('resize', cleanupScrollLock);

      dispatchTrackEvent({
        'eventCategory': 'navigation',
        'eventAction': 'open',
        'eventLabel': 'mobile menu',
        'eventValue': 5,
        'nonInteraction': false,
      }, toggleNav);

    } else {
      scrollLock.disable();

      window.removeEventListener('resize', cleanupScrollLock);

      dispatchTrackEvent({
        'eventCategory': 'navigation',
        'eventAction': 'close',
        'eventLabel': 'mobile menu',
        'eventValue': 1,
        'nonInteraction': false,
      }, toggleNav);
    }
  } else {
    toggleNav.classList.remove('open');
    nav.classList.remove('open');
    document.body.classList.remove('scroll-lock');
    scrollLock.disable();
  }
}

function cleanupScrollLock() {
  if (!isMobileMenu()) {
    scrollLock.disable();
    window.removeEventListener('resize', cleanupScrollLock);
  }
}

// Bool: mobile menu toggle is visible
function isMobileMenu() {
  return (document.querySelector('#toggleNav').clientWidth > 0);
}
